import React, { FC } from 'react';

import { Button, CloseButton } from '../../shared/ui';

interface VpnWarningBannerProps {
  onDismiss: () => void;
}

export const VpnWarningBanner: FC<VpnWarningBannerProps> = ({ onDismiss }) => {
  return (
    <div className="relative z-[1000] w-full shrink-0 bg-warning-surface border-b border-t border-warning-line px-4 py-3 flex items-center min-h-[48px]">
      <div className="absolute inset-0 flex items-center justify-center gap-2 px-4 pointer-events-none">
        <svg className="shrink-0" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 3L2 21h20L12 3z" fill="#92400e" />
          <rect x="11" y="9" width="2" height="6" rx="1" fill="white" />
          <circle cx="12" cy="17.5" r="1" fill="white" />
        </svg>
        <p className="text-ui text-warning leading-snug">
          Возможно, у Вас включён VPN . Он может ухудшать качество связи — рекомендуем отключить его перед сессией.
        </p>
      </div>

      <div className="ml-auto flex items-center gap-2 relative">
        <Button size="sm" variant="neutral" onClick={onDismiss}>
          Понятно
        </Button>
        <CloseButton size="sm" onClick={onDismiss} />
      </div>
    </div>
  );
};
